import React from 'react';
import { withTranslation } from 'react-i18next';

export const CorporateLoginForm = withTranslation()(
  ({ t, email, buttonsDisabled, onSubmitCorporateLogin, onChangeLoginEmail, onRequestRegularLogin }) => (
    <>
      <div className="change-login-email-wrapper">
        <span>{email}</span>
        <a className="link" onClick={onChangeLoginEmail}>
          {t('Change')}
        </a>
      </div>

      <p className="text-center">{t('You can sign in with your corporate Single Sign-On or Chaos account.')}</p>
      <div className="login-button-wrapper">
        <button
          id="btn-login"
          form="form-login"
          className="button btn-active"
          disabled={buttonsDisabled}
          type="button"
          onClick={onSubmitCorporateLogin}
        >
          {t('Continue with corporate email')}
        </button>
      </div>

      <span className="divider">{t('or')}</span>

      <div className="login-button-wrapper">
        <button
          form="form-login"
          className="button btn-secondary"
          disabled={buttonsDisabled}
          type="button"
          onClick={onRequestRegularLogin}
        >
          {t('Continue with Chaos account')}
        </button>
      </div>
    </>
  ),
);
